import { Header } from '../../components/Shared/NavBar/Header.jsx';
import { Seguimiento } from '../../components/Tracing/TracingTicket.jsx';
export const TracingView = () => {
  return (
    <>
      <Header />
      <Seguimiento/>
    </>
  );
};